import React from 'react'
import { Badge, Button, Card, CardContent, CardHeader } from '@/shared/ui'
import { RefreshCcw } from 'lucide-react'
import { useSwUpdateStatus } from '@/modules/pwa/hooks/useSwUpdateStatus'

export default function UpdatesCard() {
  const { supported, hasWaiting, swState, controller, checkForUpdate } = useSwUpdateStatus()
  const [checking, setChecking] = React.useState(false)

  const statusLabel = !supported
    ? 'Indisponivel'
    : hasWaiting
      ? 'Atualizacao pronta'
      : 'Sem atualizacoes pendentes'
  const statusColor = !supported ? 'warning' : hasWaiting ? 'info' : 'success'

  async function onCheck() {
    if (checking) return
    setChecking(true)
    try { await checkForUpdate() } finally { setChecking(false) }
  }

  return (
    <Card>
      <CardHeader className="text-sm font-medium">Atualizacoes</CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-center gap-2">
          <Badge variant="soft" color={statusColor}>{statusLabel}</Badge>
          {supported && (
            <span className="text-xs text-foreground/70">
              SW: {swState || 'n/a'}; controle: {String(controller)}
            </span>
          )}
        </div>
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" className="h-11" onClick={onCheck} disabled={!supported || checking}>
            <RefreshCcw className="mr-2 h-4 w-4" />
            {checking ? 'Verificando...' : 'Verificar atualizacoes'}
          </Button>
          <Button className="h-11" onClick={() => location.reload()} disabled={!supported}>
            Recarregar app
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
